export const parseBoostMultiplierSharedContent = (
  content: BoostMultiplierSharedContentType,
): BoostMultiplierSharedContent => {
  const {
    heading,
    description,
    disclaimer,
    termsTitle,
    termsList,
    aviosBoostIcon,
    removeBoostButtonLabel,
    sectionLabel,
    bestValue,
  } = content.items[0] ?? {};

  return {
    heading,
    description,
    disclaimer,
    termsTitle,
    termsList,
    aviosBoostIcon: aviosBoostIcon?.file
      ? {
          url: aviosBoostIcon.file.url,
          alt: aviosBoostIcon.title,
          title: aviosBoostIcon.title,
        }
      : undefined,
    removeBoostButtonLabel,
    sectionLabel,
    bestValue,
  };
};

type BoostMultiplierSharedContentType = {
  items: Array<{
    heading?: string;
    description?: string;
    disclaimer?: string;
    termsTitle?: string;
    termsList?: string;
    aviosBoostIcon?: {
      title?: string;
      description?: string;
      file?: {
        url: string;
      };
    };
    removeBoostButtonLabel?: string;
    sectionLabel?: string;
    bestValue?: string;
  }>;
};

export type BoostMultiplierSharedContent = {
  heading?: string;
  description?: string;
  disclaimer?: string;
  termsTitle?: string;
  termsList?: string;
  aviosBoostIcon?: {
    url: string;
    alt?: string;
    title?: string;
  };
  removeBoostButtonLabel?: string;
  sectionLabel?: string;
  bestValue?: string;
};
